import TableList from "@components/templates/tablelist";
import {
    HttpGetDestoryPlanByPage,
    HttpDestoryPlanSubmit,
    HttpDestoryPlanCancelCommit
} from "@/service/destory";
import { mapState, mapGetters } from "vuex";
import comUpdate from './update/index.vue'
import compSubmit from './../submit.vue'
import mixin from './mixin'
export default {
    mixins: [TableList, mixin],
    components: {
        comUpdate,
        compSubmit
    },
    data() {
        return {
            // totals: 0,
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {
                search: {
                    // 'IN_orderStatus':null,
                }
            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            datename: '',
            datetime: '',
            Plugins: { show: true },
            initData: '',
            warehouseList: [],
            productList: []
        };
    },
    methods: {
        ajaxRequest: HttpGetDestoryPlanByPage,
        interceptRequest: (params) => {
            return {
                ...params,
                isManage: false
            }
        },
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning('请选择至少一条数据');
            }
            switch (type) {
                case "add":
                    this.$router.push({
                        name: 'destoryUpdate',
                        params: { type: "add" },
                        // query: { id: params },
                    });
                    // var url = this.$router.resolve({
                    //     name: "destoryUpdate",
                    //     params: { type: "add" },
                    // });
                    // window.open(url.href, '_blank');
                    // this.operate = {
                    //     title: '添加',
                    //     show: true,
                    //     width: 1200,
                    //     component: "comUpdate",
                    //     id: params,
                    //     type: 'add',
                    //     showFooter: false
                    // }
                    break;
                case "edit":
                    // this.$router.push({
                    //     name: 'destoryUpdate',
                    //     params: { type: "edit" },
                    //     query: { id: params },
                    // });
                    var url = this.$router.resolve({
                        name: "destoryUpdate",
                        params: { type: "edit" },
                        query: { id: params },
                    });
                    window.open(url.href, '_blank');
                    break;
                case "query":
                    this.operate = {
                        title: '查看',
                        show: true,
                        width: 1200,
                        component: "comUpdate",
                        id: params,
                        type: 'query',
                        showFooter: false
                    }
                    break;
                case "queryBlank":
                    var url = this.$router.resolve({
                        name: "destoryUpdate",
                        params: { type: "query" },
                        query: { id: params },
                    });
                    window.open(url.href, '_blank');
                    break;
                case "submitbox":
                    // this.operate = {
                    //     show: true,
                    //     // alert: "error",
                    //     title: "提交",
                    //     width: 460,
                    //     id: params,
                    //     type: 2,
                    //     component: compSubmit,
                    //     showFooter: false,
                    // };
                    this.operate = {
                        show: true,
                        alert: "success",
                        title: this.$t('global.common.update_submit', { defaultValue: '提交' }),
                        params: { id: params },
                        ajaxRequest: HttpDestoryPlanSubmit,
                    };
                    break;
                case "cancelCommit":
                    // this.operate = {
                    //     show: true,
                    //     title: "撤销审核",
                    //     width: 460,
                    //     id: params,
                    //     type: 3,
                    //     component: compSubmit,
                    //     showFooter: false,
                    // };
                    this.operate = {
                        show: true,
                        alert: "warning",
                        title: '撤销审核',
                        params: { id: params },
                        ajaxRequest: HttpDestoryPlanCancelCommit,
                    };
                    break;
                case "cancel":
                    this.operate = {
                        show: true,
                        alert: "error",
                        title: "取消",
                        width: 460,
                        id: params,
                        type: 10,
                        component: compSubmit,
                        showFooter: false,
                    };
                    break;
                case 'export':
                    let searchData = {
                        isManage: false,
                    }
                    Object.keys(this.formData.search).map(item => {
                        searchData[`search[${item}]`] = this.formData.search[item]
                    })
                    this.handleWebfs(process.env.VUE_APP_APIURL_FBB + "/api/v2/destroyPlanOrder/export",
                        searchData
                        , {
                            executor: 'request',
                            download: true,
                        }).catch(err => {
                            this.$VMessage.error(err.message);
                        })
                    break
            }
        },
        getOperateNodeMap(row) {
            const { id, status } = row
            return [
                {
                    label: '查看',
                    show: true,
                    params: id,
                    operate: 'query'
                },
                {
                    label: '编辑',
                    show: status === 0 || status === 3,
                    params: id,
                    operate: 'edit'
                },
                {
                    label: '提交',
                    show: status === 0 || status === 3,
                    params: id,
                    operate: 'submitbox'
                }, {
                    label: '取消',
                    show: status < 4,
                    params: id,
                    operate: 'cancel'
                },
                {
                    label: '撤销审核',
                    show: status === 1,
                    params: id,
                    operate: 'cancelCommit'
                },]
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getProductList', 'getFilterDisabledWarehouse', 'getFilterDisabledWarehouse']),
        TabsData() {
            return [
                {
                    name: "全部",
                    key: 'EQ_status',
                    val: ''
                },
                {
                    name: "待审核",
                    key: 'EQ_status',
                    val: 1,
                },
                {
                    name: "审核拒回",
                    key: 'EQ_status',
                    val: 3,
                },
                {
                    name: "待销毁",
                    key: 'EQ_status',
                    val: 2
                },
                {
                    name: "销毁中",
                    key: 'EQ_status',
                    val: 4
                },
                {
                    name: "已完成",
                    key: 'EQ_status',
                    val: 5
                },
            ]
        },
        ToolsData() {
            return [
                {
                    name: "添加",
                    operate: "add",
                    theme: "primary",
                },
                {
                    name: '导出',
                    operate: 'export',
                    theme: 'primary'
                },
            ]
        },
        SearchsData() {
            let widthStyle = 'width: 220px;'
            return [
                {
                    label: "销毁计划单号",
                    tag: 'vInput',
                    key: 'EQ_destroyPlanOrderNo',
                    show: true,
                    style: 'width: 120px;'
                },
                {
                    label: "来源单号",
                    tag: 'vInput',
                    key: 'EQ_sourceNo',
                    show: true,
                    style: 'width: 120px;'
                },
                {
                    label: "状态",
                    tag: 'Select',
                    key: 'IN_status',
                    show: true,
                    options: this.statusList,
                    props: {
                        filterable: true,
                        multiple: true
                    },
                    style: 'width: 120px;'
                },
                {
                    label: "库存类型",
                    tag: 'Select',
                    key: 'IN_inventoryType',
                    options: this.stockTypeList,
                    style: widthStyle
                },
                {
                    label: this.$t('global.common.line', { defaultValue: '项目' }),
                    key: 'EQ_lineId',
                    tag: 'Select',
                    options: this.getProductList,
                    props: {
                        filterable: true,
                    },
                    style: widthStyle
                },
                {
                    label: "仓库",
                    tag: 'Select',
                    key: 'IN_orgWarehouseId',
                    options: this.getFilterDisabledWarehouse,
                    props: {
                        filterable: true,
                    },
                    style: widthStyle
                },
                {
                    label: "创建日期",
                    tag: 'vDatepicker',
                    key: 'BT_createdAt',
                    // default:this.initData,
                    props: {
                        options: this.options,
                        format: 'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm: false,
                    },
                    style: widthStyle
                },
            ]
        },
        columns() {
            return [
                {
                    show: false,
                    type: 'selection',
                    width: 40,
                    align: 'center',
                    formName: 'id',
                    // fixed: 'left'
                }, {
                    title: '操作',
                    width: 70,
                    render: this.getOperateNodes,
                    // fixed: 'left'
                }, {
                    title: '销毁计划单号/来源单号',
                    sortable: true,
                    // fixed: 'left',
                    render: (h, { row }) => {
                        return <div>
                            <div>
                                <a onClick={this.handleOperates.bind(this, row.id, 'query')}>{row.destroyPlanOrderNo || '--'}</a>
                                <a onClick={this.handleOperates.bind(this, row.id, 'queryBlank')}><vIcon class="margin-left-10 font-14" type="ios-browsers-outline" /></a>
                            </div>
                            <div>{row.sourceNo || '--'}</div>
                        </div>
                    }
                },
                {
                    title: '状态',
                    // key: 'sourceChannel',
                    // width: (this.formData.search['quanbu'] === 0) ? 100 : 'auto',
                    render: (h, { row }) => {
                        let statusName = this.statusList.filter(item => {
                            return item.value === row.status
                        })[0] || {}
                        return (
                            <div>
                                <div class={statusName.theme || ''}>{statusName.label || '--'}</div>
                            </div>
                        )
                    }
                },
                {
                    title: '项目/库存类型',
                    render: (h, { row }) => {
                        // let product = this.getProductList.filter(item => {
                        //     // console.log
                        //     return item.value === row.lineId
                        // })[0] || {}
                        let inventoryType = this.stockTypeList.filter(item => {
                            return item.value === row.inventoryType
                        })[0] || {}
                        return <div>
                            <div>{row.lineName || '--'}</div>
                            <div>{inventoryType.label}</div>
                        </div>
                    }
                },
                {
                    title: '仓库',
                    // width: 60,
                    render: (h, { row }) => {
                        // let warehouse = this.getFilterDisabledWarehouse.filter(item => {
                        //     return item.value === row.orgWarehouseId
                        // })[0] || {}
                        return <div>
                            <div>{`${row.orgWarehouseCode}(${row.orgWarehouseName})`}</div>
                        </div>
                    }
                },
                {
                    title: '更新时间',
                    key: 'updatedAt',
                    width: 180,
                    render: (h, { row }) => {
                        return <div>
                            <div>{row.updatedAt}</div>
                        </div>
                    }
                },
            ];
        },

    },

};
